资料录入分组

<template>
  <el-container class="self-module" v-if="isShow">
    <el-header>
      <div class="title">
        <div v-if="module.isCustomModuleTitle" class="customTitle">
          <div class="custom_module_title__text">{{ module.MODULE_TITLE }}</div>
        </div>
        <h3 v-else>
          <!-- <div class="placeholder-box"></div> -->
          <img src="../../../static/assets/img/oldCode/title-icon.png"/>
          <span class="title__txt" v-show="isShowModule">
            {{ module.MODULE_TITLE }}
            <span class="order">{{ moduleOrder }}</span>
          </span>

          <div class="btn-wrap">
            <!-- 模块收起时简略信息 -->
            <div class="btn-child-wrap brief" v-if="!isShowModule">
              <div v-for="item in module.brief_data" :key="item.id">
                <span :class="item.class" v-html="item.html"></span>
              </div>
            </div>
            <!-- 模块功能按钮 -->
            <div class="btn-child-wrap" v-show="!disabled && isShowModule">
              <el-checkbox class="check-module" v-model="withoutChecked" @change="withoutChangeModule" v-if="isWithout">
                {{ module.MODULE_WITHOUT_TXT || "无（若无，可不申报）" }}
              </el-checkbox>
              <el-checkbox class="check-module" v-model="sameChecked" @change="sameChangeModule" v-if="isSame">
                {{ module.MODULE_SAME_TXT || '同"信托产品委托人"' }}
              </el-checkbox>
              <el-button class="read-module" @click="readModule" v-if="isRead" round>
                {{ module.MODULE_CONTROL_TXT || "识别" }}
              </el-button>
              <el-button class="clear-module" @click="clearModule" v-if="isClear" round>
                {{ module.MODULE_CLEAR_TXT || "清空" }}
              </el-button>
              <el-button class="read-module zd-customize-module" @click="ZDCustomizeModule" v-if="isZDCustomize" round>
                {{ module.MODULE_ZDCUSTOMIZE_TXT || "中登校验" }}
              </el-button>
              <el-button class="read-module" @click="customizeModule" v-if="isCustomize" round>
                {{ module.MODULE_CUSTOMIZE_TXT || "公安联网" }}
              </el-button>

              <span class="message" v-if="isShowMessage">
                <i class="el-icon-warning"></i>
                {{ module.MODULE_MESSAGE_TXT }}
              </span>

            </div>
            <div class="btn-child-wrap right-start" v-show="!disabled">
              <el-button class="query-module" @click="queryModule" v-if="isQuery">
                <!-- <div style="font-size: 0.22rem;margin-right: 0.08rem;">  </div>-->
                  <Icon type="ios-search" />
                  {{ module.MODULE_QUERY_TEXT || "中登查询" }}
              </el-button>
              <el-button class="add-module" v-if="isAdd"  @click="addModule" round>
                  <i class="el-icon-plus icon_add"></i>
                {{ module.MODULE_ADD_TEXT || "添加"}}
              </el-button>
              <el-button class="delete-module" v-if="isDelete" @click="deleteModule" round>
                <i class="el-icon-delete"></i>
                删除
              </el-button>
              <el-button class="add-module mock-btn" v-if="isDownload" round>
                {{ module.MODULE_DOWNLOAD_TXT || "下载模版" }}
                <a :href="module.MODULE_DOWNLOAD_LINK"  :download="module.MODULE_DOWNLOAD_NAME" round></a>
              </el-button>
              <!-- <a class="downButton" :href="module.MODULE_DOWNLOAD_LINK" v-if="isDownload" :download="module.MODULE_DOWNLOAD_NAME" round>
                {{ module.MODULE_DOWNLOAD_TXT || "下载模版" }}
              </a> -->
              <el-button class="add-module mock-btn" v-if="isImport" round>
                {{ module.MODULE_IMPORT_TXT || "导入" }}
                <input type="file" name="file" style="display: none;" ref="filePartner" @change="fileChange" />
                <a href="javascript:void(0);" class="importButton" @click="importPartners"></a>
              </el-button>
              <!-- <span v-if="isImport">
                <input type="file" name="file" style="display: none;" ref="filePartner" @change="fileChange" />
                <a href="javascript:void(0);" class="importButton" @click="importPartners">
                  <span></span>
                  {{module.MODULE_IMPORT_TXT || '导入'}}
                </a>
              </span> -->
              <el-button v-if="isFoldUp" @click="fold" round>
                <span v-show="isShowModule">
                  收起 <i class="el-icon-caret-top"></i>
                </span>
                <span v-show="!isShowModule">
                  展开 <i class="el-icon-caret-bottom"></i>
                </span>
              </el-button>
            </div>
          </div>
        </h3>
      </div>
    </el-header>
    <el-main v-show="isShowModule" >
      <div :class="{'fieldset': true, 'disabled': disabled, 'self-item': module.isCustomModuleTitle, 'long-el-form-item': field.isLongItem}" :is="field.component" :ref="field.FIELD_ID" :field.sync="field" :key="field.FIELD_SEQ"
        v-for="field in fields" :index="index" :name="module.MODULE_ID+'-'+module.MODULE_SEQ+'-'+field.FIELD_ID"
        :groupId="module.GROUP_ID" :moduleid="module.MODULE_ID" :busiLogic="busiLogic"></div>
    </el-main>
    <flowTip :ref="moduleFlowTipName"></flowTip>
    <!-- <el-footer>
      <div class="bottom-button-wrap">
        <el-button class="add-module" @click="addModule" v-if="isAdd" round>
          <i class="el-icon-plus"></i>
          <span>{{ module.MODULE_ADD_TEXT || "添加" }}</span>
        </el-button>
      </div>
    </el-footer> -->
  </el-container>
</template>

<script>
import addressInputItem from "../../components/preEntry/addressInputItem";
import checkerItem from "../../components/preEntry/checkerItem";
import checkerItemExtend from "../../components/preEntry/checkerItemExtend";
import radioItem from "../../components/preEntry/radioItem";
import datePickItem from "../../components/preEntry/datePickItem";
import normalInputItem from "../../components/preEntry/normalInputItem";
import selectorItem from "../../components/preEntry/selectorItem";
import multiSelectorItem from "../../components/preEntry/multiSelectorItem";
import telephoneInputItem from "../../components/preEntry/telephoneInputItem";
import normalTextItem from "../../components/preEntry/normalTextItem";
// import normalPhotoItem from "../../components/preEntry/normalPhotoItem";
import normalOcrItem from "../../components/preEntry/normalOcrItem";
import normalButtonItem from "../../components/preEntry/normalButtonItem";
import flowTip from "../../components/common/flowTip";
import countryPickItem from "../../components/preEntry/countryPickItem";
import normalTitleItem from "./normalTitle.vue";
import openBizStockItem from "./openBizStockItem";
import autoComplete from "./autoComplete";//更换谷歌后需要改回普通下拉框

const comps = {
  addressInput: addressInputItem,
  checker: checkerItem,
  checkerExtend: checkerItemExtend,
  radio: radioItem,
  date: datePickItem,
  normalinput: normalInputItem,
  selector: selectorItem,
  multiSelector: multiSelectorItem,
  telephone: telephoneInputItem,
  normalText: normalTextItem,
  normalButton: normalButtonItem,
  flowTip: flowTip,
  countryPick: countryPickItem,
  normalTitle: normalTitleItem,
  openBizStock: openBizStockItem,
  autoComplete: autoComplete,
  // normalPhoto: normalPhotoItem,
  normalOcr: normalOcrItem,
};

export default {
  data () {
    return {
      moduleInit: {},
      fields: [],
      module: this.moduleItem,
      isZDCustomize: false,
      isCustomize: false,
      isShowModule: true,
      isDownload: false,
      isImport: false,
      isShowMessage: false,
      withoutChecked: false,
      sameChecked: false
    };
  },
  mounted () {
    this.moduleInit = _.cloneDeep(
      this.parentPage.groupDatasTpl[this.module.GROUP_ID][
        this.module.MODULE_ID
      ][0]
    );
    this.parseModule(this.module.FIELDS);

    if (this.isFoldUp && !this.showModule) {
      this.isShowModule = this.showModule;
    }
  },
  activated () {
    this.module = this.moduleItem;
    this.parseModule(this.module.FIELDS);
  },
  props: ["moduleItem", "index", "busiLogic","disabled"],
  components: comps,
  computed: {
    //不传这个值默认是展开的，传1也是，传0就是折叠的
    showModule () {
      return this.module.SHOW_MODULE_FOLD == undefined || parseInt(this.module.SHOW_MODULE_FOLD) ? true : false;
    },
    isShow: function () {
      return parseInt(this.module.MODULE_CONTROL) ? true : false;
    },
    isAdd: function () {
      return parseInt(this.module.MODULE_ADD) ? true : false;
    },
    isQuery: function () {
      return parseInt(this.module.MODULE_QUERY) ? true : false;
    },
    isDelete: function () {
      return parseInt(this.module.MODULE_DELETE) ? true : false;
    },
    isClear: function () {
      return parseInt(this.module.MODULE_CLEAN) ? true : false;
    },
    isRead: function () {
      //   //安卓的不显示拍照填写，iOS的才显示
      //   if(this.$basecfg.platform === "android"){
      //     return false;
      //   }
      return parseInt(this.module.MODULE_READ) ? true : false;
    },
    isWithout: function () {
      return parseInt(this.module.MODULE_WITHOUT) ? true : false;
    },
    isSame: function () {
      return parseInt(this.module.MODULE_SAME) ? true : false;
    },
    isFoldUp: function () {
      return parseInt(this.module.MODULE_FOLD) ? true : false;
    },
    isFoldViladate: function () {
      return parseInt(this.module.MODULE_FOLD_VILDATE) ? true : false;
    },
    // isShowMessage: function () {
    //   return this.module.MODULE_MESSAGE || false;
    // },
    // isCustomize: function() {
    //     return parseInt(this.module.MODULE_CUSTOMIZE) ? true : false;
    // },
    // 从路由配置中获取模块最大长度
    mdMaxLen: function () {
      let currRoute = this.$router.getCurrentRoute(),
        modules = currRoute.modulesWithMaxLen || currRoute.modules || [],
        mdMaxLen = currRoute.mdMaxLen || 0;
      if (modules.length === 0 || mdMaxLen === 0) {
        return 0;
      }
      if (modules.includes(this.moduleItem.MODULE_ID)) {
        return mdMaxLen;
      } else {
        return 0;
      }
    },
    maxLength: function () {
      // 最大可添加组数 默认为4组
      return this.module.MAX_LENGTH || this.mdMaxLen || 4;
    },
    moduleOrder: function () {
      if (
        this.parentPage.moduleDatas[this.module.MODULE_ID].length > 1 &&
        this.parentPage.moduleDatas[this.module.MODULE_ID][0]["MODULE_TITLE"] ==
        this.parentPage.moduleDatas[this.module.MODULE_ID][1]["MODULE_TITLE"]
      ) {
        // 一柜通有同一个数据结构但不同模块，需要单独处理分开下
        return "(" + (this.index + 1) + ")";
      } else {
        return "";
      }
    },
    parentPage: function () {
      return this.$parent.$parent.$parent.$parent;
    },
    moduleFlowTipName () {
      return this.moduleItem.MODULE_ID + "_FLOW_TIP";
    },
    //为中登查询按钮判断是否显示
    isZDQuery: function () {
      if(this.module.MODULE_ID == "TRDACCT_MODULE"){
        return true;
      }else{
        return false;
      }
    },
  },
  watch: {
    "module.MODULE_CUSTOMIZE": {
      handler (newVal, oldVal) {
        this.isCustomize = parseInt(this.module.MODULE_CUSTOMIZE)
          ? true
          : false;
      },
      deep: true,
      immediate: true
    },
    "module.MODULE_ZDCUSTOMIZE": {
      handler (newVal, oldVal) {
        this.isZDCustomize = parseInt(this.module.MODULE_ZDCUSTOMIZE)
          ? true
          : false;
      },
      deep: true,
      immediate: true
    },
    "module.MODULE_DOWNLOAD": {
      handler (newVal, oldVal) {
        this.isDownload = parseInt(this.module.MODULE_DOWNLOAD)
          ? true
          : false;
      },
      deep: true,
      immediate: true
    },
    "module.MODULE_IMPORT": {
      handler (newVal, oldVal) {
        this.isImport = parseInt(this.module.MODULE_IMPORT)
          ? true
          : false;
      },
      deep: true,
      immediate: true
    },
    "module.MODULE_MESSAGE": {
      handler (newVal, oldVal) {
        this.isShowMessage = this.module.MODULE_MESSAGE
          ? true
          : false;
      },
      deep: true,
      immediate: true
    },
    moduleItem (v) {
      this.module = v;
      this.parseModule(this.module.FIELDS);
    },
    "module.withoutChecked": {
      handler: function () {
        this.withoutChecked = this.module.withoutChecked;
      },
      deep: true,
      immediate: true
    },
    "module.sameChecked": {
      handler: function () {
        this.sameChecked = this.module.sameChecked;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /**
     * @method getTypeLength
     * @desc 把流程提示组件的方法直接挂载到bizEntry实例上
     * @param  {String} type 提示类型 success/warning/info/error
     * @return {Number} 如果有就是对应项目的index 否则返回0
     */
    getTypeLength (type) {
      return this.$refs[this.moduleFlowTipName].getTypeLength(type);
    },
    /**
     * @method pushFlowTip
     * @desc 添加提示信息
     * @param  {Object} tip 提示内容对象
     */
    pushFlowTip (tip) {
      this.$refs[this.moduleFlowTipName].pushFlowTip(tip);
    },
    /**
     * @method removeFlowTip
     * @desc 删除提示信息
     * @param  {Object} tip 提示内容对象
     */
    removeFlowTip (key) {
      this.$refs[this.moduleFlowTipName].removeFlowTip(key);
    },
    readModule () {
      //更改state的值，触发全局的字段赋值事件
      let data = {};
      data["MODULE_ID"] = this.moduleItem.MODULE_ID;
      data["GROUP_ID"] = this.moduleItem.GROUP_ID;
      data["MODULE_NUM"] = this.moduleItem.MODULE_NUM;
      this.$store.commit(this.$types.UPDATE_MODULE_BUTTON_CLICK, data);
    },
    customizeModule () {
      //更改state的值，触发全局的字段赋值事件
      let data = {};
      data["MODULE_ID"] = this.moduleItem.MODULE_ID;
      data["GROUP_ID"] = this.moduleItem.GROUP_ID;
      data["MODULE_SEQ"] = this.moduleItem.MODULE_SEQ;
      //自定义按钮
      this.$store.commit(
        this.$types.UPDATE_MODULE_CUSTOMIZE_BUTTON_CLICK,
        data
      );
    },
    ZDCustomizeModule () {
      //更改state的值，触发全局的字段赋值事件
      let data = {};
      data["MODULE_ID"] = this.moduleItem.MODULE_ID;
      data["GROUP_ID"] = this.moduleItem.GROUP_ID;
      data["MODULE_SEQ"] = this.moduleItem.MODULE_SEQ;
      this.$store.commit(
        this.$types.UPDATE_MODULE_ZDCUSTOMIZE_BUTTON_CLICK,
        data
      );
    },
    importPartners () {
      this.$refs.filePartner && this.$refs.filePartner.click();
    },
    //解析合伙人信息
    fileChange (event) {
      if (!event.target.files) {
        return;
      }
      this.myLoading({

        loadingText: "正在导入...",
        autoHide: false
      });
      let _this = this;
      let fileObj = event.target.files[0];
      event.target.value = "";
      if (fileObj.name.indexOf("xlsx") != -1 || fileObj.name.indexOf("xls") != -1) {
        let reader = new FileReader();
        reader.onload = function (e) {
          var data = e.target.result;
          _this.readData = XLSX.read(data, {
            type: "binary"
          });
          let arr = XLSX.utils.sheet_to_json(_this.readData.Sheets[_this.readData.SheetNames[0]]);
          _this.myLoading({
            showLoading: false
          });
          if (!arr.length) {
            _this.alert("导入数据为空");
            return;
          }
          _this.$store.commit(
            _this.$types.UPDATE_MODULE_IMPORT_BUTTON_CLICK,
            arr
          );
        };
        reader.readAsBinaryString(fileObj);
      } else {
        _this.alert("文件格式不正确，请重新选择！");
        _this.myLoading({
          showLoading: false
        });
      }
    },
    withoutChangeModule (isChecked, el) {
      let that = this;
      that.withoutChecked = isChecked;
      //给展开一个回调，然后方便做处理
      Promise.resolve()
        .then(() => {
          let data = {};
          data["MODULE_ID"] = that.moduleItem.MODULE_ID;
          data["GROUP_ID"] = that.moduleItem.GROUP_ID;
          data["MODULE_SEQ"] = that.moduleItem.MODULE_SEQ;
          data["MODULE_CHECKED"] = isChecked; //是否选中 true 选中
          data["MODULE_EL"] = el;
          return that.parentPage.moduleCustomizeWithoutChange(data);
        }).then((flag) => {
          that.moduleItem.withoutChecked = flag;
          that.withoutChecked = flag;
          flag && (that.sameChecked = false);
          consoleLog(flag);
        }).catch(err => {
          that.moduleItem.withoutChecked = false;
          that.withoutChecked = false;
          consoleError("-------------无模块出错了--------------", err);
        });
    },
    sameChangeModule (isChecked, el) {
      let that = this;
      that.sameChecked = isChecked;
      //给展开一个回调，然后方便做处理
      Promise.resolve()
        .then(() => {
          let data = {};
          data["MODULE_ID"] = that.moduleItem.MODULE_ID;
          data["GROUP_ID"] = that.moduleItem.GROUP_ID;
          data["MODULE_SEQ"] = that.moduleItem.MODULE_SEQ;
          data["MODULE_CHECKED"] = isChecked; //是否选中 true 选中
          data["MODULE_EL"] = el;
          data["withoutChecked"] = that.withoutChecked;
          return that.parentPage.moduleCustomizeSameChange(data);
        }).then((data) => {
          let flag = data[0] || false;
          let sameArr = data[1];
          let currentArr = data[2];
          let exceptFields = data[3] && data[3].split(",");
          let callbackFun = data [4];
          that.moduleItem.sameChecked = flag;
          that.sameChecked = flag;
          if (flag) {
            let currentLen = 0;
            Promise.resolve()
              .then(() => {
              // 创建添加模块的Promise数组
                const addModulePromises = [];
                _.each(sameArr, function (item, index) {
                  currentLen = index + 1;
                  //无值则进行模块添加
                  if (!currentArr[index]) {
                    addModulePromises.push(that.addModule(true));
                  }
                });
                // 等待所有添加模块操作完成
                return Promise.all(addModulePromises);
              }).then(() => {
                //删除多余模块
                if (currentLen < currentArr.length) {
                  for (let i = currentLen; i < currentArr.length; i++) {
                    that.deleteModuleHandler(currentArr[i].MODULE_ID, i);
                  }
                }
                //数据的同步
                _.each(sameArr, function (item, index) {
                  if (currentArr[index]) {
                    let moduleId = currentArr[index].MODULE_ID;
                    let currentData = that.parentPage.moduleDatas[moduleId][index];
                    _.each(currentData.FIELDS, function (fieldObj, field){
                      if (!_.includes(exceptFields, field)) {
                        //赋值要异步原因是，每个字段的函数处理都是异步，如果同步无法生效
                        setTimeout(() => {
                          fieldObj.DEFAULT_VALUE = item.FIELDS[field].DEFAULT_VALUE;
                          fieldObj.FIELD_CONTROL = item.FIELDS[field].FIELD_CONTROL;
                          fieldObj.FIELD_REQUIRED = item.FIELDS[field].FIELD_REQUIRED;
                        }, 1);
                      }
                    });
                    setTimeout(() => {
                      index !== 0 && (currentData.MODULE_SAME = "0");
                      currentData.MODULE_CUSTOMIZE = "";
                      currentData.MODULE_READ = item.MODULE_READ;
                      currentData.MODULE_ADD = (sameArr.length - 1 === index ? "1" : "0");
                    }, 2);
                  }
                });
              }).then(() => {
                _.isFunction(callbackFun) && callbackFun(that);
              });
          }
          consoleLog(flag);
        }).catch(err => {
          that.moduleItem.sameChecked = false;
          that.sameChecked = false;
          consoleError("-------------同步弹窗模块出错了--------------", err);
        });
    },
    clearModule () {
      //更改state的值，触发全局的字段赋值事件
      if (
        this.parentPage.moduleDatas[this.module.MODULE_ID].length > this.index
      ) {
        for (let fk in this.parentPage.moduleDatas[this.module.MODULE_ID][
          this.index
        ].FIELDS) {
          this.parentPage.moduleDatas[this.module.MODULE_ID][this.index].FIELDS[
            fk
          ]["DEFAULT_VALUE"] = "";
        }
      }

      if (this.parentPage.clearModuleClick) {
        let data = {};
        data["MODULE_ID"] = this.moduleItem.MODULE_ID;
        data["GROUP_ID"] = this.moduleItem.GROUP_ID;

        this.parentPage.clearModuleClick(data);
      }
    },
    addModule: function (isSame) {
      // 是否是同步模块
      isSame = isSame === true;
      let that = this;
      let index = that.parentPage.moduleDatas[this.module.MODULE_ID].length - 1; // 记录最后一个模块的位置
      Promise.resolve()
        .then(() => {
          let data = {};
          data["MODULE_ID"] = that.moduleItem.MODULE_ID;
          data["GROUP_ID"] = that.moduleItem.GROUP_ID;
          data["INDEX"] = index;

          return that.parentPage.addModuleClick(data); //
        })
        .then(isAllow => {
          //如果通过了自定义的检查，还需要过通用检查才能添加分组
          if (isAllow) {
            // 要先判断这添加前的组该填的都已经填写
            let flag = true;
            let totalVisibleField = 0; //显示的可见的字段数量
            let emptyField = 0; //空值的字段总数
            for (let fsName in that.module.FIELDS) {
              let fs = that.module.FIELDS[fsName];
              if (fs.FIELD_CONTROL == "0" || fs.FIELD_CONTROL == "2") {
                totalVisibleField++;
                if (fs.DEFAULT_VALUE == "" || fs.DEFAULT_VALUE == undefined) {
                  if (fs.FIELD_REQUIRED == "1") {
                    flag = false;
                    break;
                  } else {
                    emptyField++;
                  }
                }
              }
            }
            if (!isSame && (emptyField == totalVisibleField)) {
              //如果非必填且为空值的字段数量跟显示的可见的字段数量一致,
              //说明当前模块字段均为非必填且全部空值,此时至少要填写一个值才能添加下一个分组
              flag = false;
              that.alert("请填写至少一个或以上字段");
              return;
            }
            // 添加分组
            //isSame 模块同步不再校验本模块未填写数据， 非同步模块需要校验
            if(isSame){
              flag = true;
            }
            if (flag) {
              that.module["MODULE_ADD"] = "0"; // 把当前的添加按钮关闭，只留最后一个
              for (let fk in that.moduleInit.FIELDS) {
                //先更新过滤项在增加模块
                that.moduleInit.FIELDS[fk].FIELD_DICT_FILTER =
                  that.parentPage.moduleDatas[that.module.MODULE_ID][0].FIELDS[
                    fk
                  ].FIELD_DICT_FILTER;
              }
              let module2 = _.cloneDeep(that.moduleInit);
              module2["MODULE_DELETE"] = "1";

              if (
                that.maxLength &&
                that.parentPage.moduleDatas[that.module.MODULE_ID].length + 1 >
                that.maxLength
              )
                module2["MODULE_ADD"] = "0";
              else module2["MODULE_ADD"] = "1";
              //强制显示新增的分组
              module2["MODULE_CONTROL"] = "1";
              module2["MODULE_SEQ"] = parseInt(that.module["MODULE_SEQ"]) + 1 + "";
              // module2["MODULE_NUM"] = parseInt(that.module["MODULE_NUM"]) + 1 + ""; //去掉MODULE_NUM 添加序号赋值，为空默认新增模块

              //模块位置标示相当于一柜通多模块的key字段，用于模块数据回填 递增与数组长度无关
              let number = parseInt(that.module["MODULE_NUMBER"] || 0) + 1 + "";
              module2["MODULE_NUMBER"] = number + "";
              //新增后的模块在数组中的下标，递增，默认是当前的数组长度
              module2["MODULE_NUM"] = that.parentPage.moduleDatas[this.module.MODULE_ID].length + "";
              for (let fsName in module2.FIELDS) {
                let fs = module2.FIELDS[fsName];
                fs.MODULE_NUMBER = number;
                fs.MODULE_NUM = module2["MODULE_NUM"];
              }

              //隐藏与XX一致单选框
              if (module2.FIELDS.MODULE_RADIO_BUTTON != undefined) {
                module2.FIELDS.MODULE_RADIO_BUTTON.FIELD_CONTROL = "1";
              }
              //如果当前有自定义按钮则添加的时候继承自定义按钮的展示以及文字
              if (that.module["MODULE_CUSTOMIZE"]) {
                module2.MODULE_CUSTOMIZE = "1";
                module2.MODULE_CUSTOMIZE_TXT = that.module.MODULE_CUSTOMIZE_TXT;
              }
              if (that.module["MODULE_ZDCUSTOMIZE"]) {
                module2.MODULE_ZDCUSTOMIZE = "1";
                module2.MODULE_ZDCUSTOMIZE_TXT =
                  that.module.MODULE_ZDCUSTOMIZE_TXT;
              }
              //moduleinit是取自服务器最原始的分组字段结构，有些字段默认是隐藏的，新增模块也不应该显示出来，如有特殊需求可在各自业务的addModuleFinished钩子函数实现 by林思聪
              // Object.getOwnPropertyNames(module2.FIELDS).map(item =>{
              //   // if(item !== "MODULE_RADIO_BUTTON" && item !== "LINKMAN_NO" && item !== "CONTROLER_NUM" &&
              //   //  item !== "BENEFICIARY_NO" && item !== "STOCKHOLDER_NO" && item !== "LINKMAN_INFO_NO" &&
              //   //  item !== "CONTROLLER_NO" && item !== "BENEFICIARY_OWNER"){
              //     // module2.FIELDS[item].DEFAULT_VALUE ="";
              //     // module2.FIELDS[item].FIELD_CONTROL="0";
              //   // }
              // });
              //添加的新结构

              that.parentPage.moduleDatas[that.module.MODULE_ID].push(module2);
              that.parentPage.addModuleFinished(module2, that.parentPage.moduleDatas[that.module.MODULE_ID]); //添加完成的回调钩子，可以在业务V00XX.js中回调响应，根据业务需求自己处理
              // that.$nextTick(() => {
              //   var container = document.getElementsByClassName(
              //     "bizEntry-main"
              //   )[0];
              //   container.scrollTop = container.scrollHeight;
              // });
            } else {
              that.alert("请先填写完必填字段");
            }
          } else {
            // that.alert("请先填写完必填字段");
            return;
          }
        })
        .catch(err => {
          consoleLog("-------------增加模块出错了--------------", err);
        });
    },
    deleteModule: function () {
      let that = this;
      this.alert({
        messageText: "您确定要删除此条记录吗",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmedAction: function () {
          that.deleteModuleHandler(that.module.MODULE_ID, that.index);
        }
      });
    },
    deleteModuleHandler: function (moduleId, seq){
      let that = this;
      that.parentPage.moduleDatas[moduleId].splice(seq, 1);
      that.parentPage.deleteModuleFinished(that.parentPage.moduleDatas[moduleId]); //添加完成的回调钩子，可以在业务V00XX.js中回调响应，根据业务需求自己处理
      that.parentPage.moduleDatas[moduleId][that.parentPage.moduleDatas[moduleId].length - 1].MODULE_ADD = "1";
      that.$store.commit(that.$types.UPDATE_FIELD_CHANGE, {
        module_id: moduleId,
        field_id: null,
        index: null
      });
      //更新MODULE_NUM。删除中间元素，比如0,1,2 删除2，剩余0跟2，另外2个应该自动变为0,1
      _.forEach(that.parentPage.moduleDatas[moduleId] || [], (md, index) => {
        md.MODULE_NUM = index;
      });
    },
    queryModule: function () {
      let that = this;
      that.parentPage.queryModule(that.parentPage.moduleDatas[that.module.MODULE_ID]);
    },
    parseModule: function (data) {
      if (
        this.isAdd &&
        this.index ==
        this.parentPage.moduleDatas[this.module.MODULE_ID].length - 1 &&
        (this.maxLength == 0 || this.index + 1 < this.maxLength)
      ) {
        this.module["MODULE_ADD"] = "1";

      }
      else {// 最后一组显示添加按钮
        this.module["MODULE_ADD"] = "0";
      }

      if (this.index != 0 && this.moduleInit["MODULE_ADD"] == "1")
        this.module["MODULE_DELETE"] = "1";
      // 如果不是第一组显示删除按钮
      else this.module["MODULE_DELETE"] = "0";

      // data.sort(this.by("FIELD_SEQ")); 现在已按后台排序？
      for (let i in data) {
        let d = data[i];
        // pageactive触发的check事件不能获得module，需要在filed对象也添加MODULE_NUMBER;
        d.MODULE_NUMBER = this.module.MODULE_NUMBER;
        d.MODULE_NUM = this.module.MODULE_NUM;
        if (d.FIELD_TYPE in comps) d.component = d.FIELD_TYPE;
        // 默认通用输入框
        else d.component = "normalinput";
      }

      this.fields = data;
    },
    // by: function(name){ // 用于数组字典排序
    //  return function(o, p){
    //     var a, b;
    //     if (typeof o === "object" && typeof p === "object" && o && p) {
    //       a = o[name];
    //       b = p[name];
    //       if (a === b) {
    //         return 0;
    //       }
    //       a = parseInt(a);
    //       b = parseInt(b);
    //       return a < b ? -1 : 1;
    //     }
    //     else {
    //       throw ("error");
    //     }
    //   }
    // }
    fold () {
      if (this.isShowModule) {
        this.foldUp();
      } else {
        this.unfold();
      }
    },
    foldUp () {
      let that = this;
      Promise.resolve()
        .then(() => {
          let data = {};
          data["MODULE_ID"] = that.moduleItem.MODULE_ID;
          data["GROUP_ID"] = that.moduleItem.GROUP_ID;
          data["MODULE_NUMBER"] = that.moduleItem.MODULE_NUMBER;
          return that.parentPage.foldModuleClick(data); //
        })
        .then(isAllow => {
          //如果通过了自定义的检查，还需要过通用检查才能收起模块
          //检查模块是否有不符合校验规则的字段
          if (!that.isFoldViladate) {
            if (isAllow) {
              let error = [];
              let mdd = that.moduleItem;
              for (let field of Object.values(that.moduleItem["FIELDS"])) {
                let filed_vue = this.$refs[field.FIELD_ID][0];
                //隐藏的，作废的字段不执行校验
                if (field.FIELD_CONTROL == "1" || field.FIELD_CONTROL === "3" || field.FIELD_TYPE === "normalTitle") {
                  continue;
                }
                //触发fileds校验方法
                filed_vue.$refs[field.FIELD_ID].validate("blur");
                filed_vue.$refs[field.FIELD_ID].validate("custom");

                if (filed_vue.field.message !== "") {
                  error.push(filed_vue.field.message);
                }
              }
              if (error.length == 0) {
                this.isShowModule = false;
              }
            }
          } else {
            this.isShowModule = false;
          }
        })
        .catch(err => {
          consoleLog("-------------增加模块出错了--------------", err);
        });
    },
    unfold () {
      let that = this;
      this.isShowModule = true;
      //给展开一个回调，然后方便做处理
      Promise.resolve()
        .then(() => {
          let data = {};
          data["MODULE_ID"] = that.moduleItem.MODULE_ID;
          data["GROUP_ID"] = that.moduleItem.GROUP_ID;
          data["MODULE_NUMBER"] = that.moduleItem.MODULE_NUMBER;
          return that.parentPage.unfoldModuleClick(data); //
        }).then((data) => {
          consoleLog(data);
        }).catch(err => {
          consoleError("-------------收起模块出错了--------------", err);
        });
    }
  },
  beforeDestroy () {
    consoleLog("moduleItem-beforeDestroy");

  },

};
</script>

<style lang="less">
@import "~@/styles/less/variable.less";
.self-module {
  .el-header {
    margin-bottom: 24px;
    padding: 0;
    padding:0 16px 0 16px;//新增，设置主标题增加左边距
    height: initial !important;
    // background-color: red;//f6f6f6
    .title {
      .custom_module_title__text{
        font-size: 22px;
        color: #252525;
        text-align: center;
        font-weight: 400;
      }
      h3 {
        height: 50px;
        position: relative; /* 为子组件创建相对定位的参照点 */
        background-color: #F7F8F9;//f6f6f6、F7F8F9
        // padding: 1% 3% 1% 3%;
        padding: 8px 40px 8px 8px;
        .module-title();
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0;
        .placeholder-box {
          display: none;
        }
        .title__txt {
          display: flex;
          align-items: center;
          font-size: 18px;// 字体大小
          &::before {
            content: "";
            width: 14px;
          }
        }
        .btn-wrap {
          display: flex;
          justify-content: space-between;
          flex-grow: 1;
          padding: 0 0 0 30px;
          .btn-child-wrap {
            min-width: 100px;
            .right-start {
              display: flex;
              justify-content: flex-end;
            }
            .el-button {
              width: 90px;
              // height: 42px;
              padding: 5px 8px;
              border-radius: 21px;
              color: #4a90e2;
              border-color: #4a90e2;
              font-size: 14px;
              &.delete-module {
                // border: 2px solid #ff2b1b;
                background-color: transparent;
                border: none;
                color: #ff2b1b;
              }
              &.add-module{
                background-color: transparent;
                border: none;
                color: #D0AA72;
                .icon_add{
                  // display: inline-block;
                  // line-height: 1.2;
                  // width: 0.18rem;
                  // height: 0.18rem;
                  // min-width: 12px;
                  // min-height: 12px;
                  border-radius: 50%;
                  background: #D0AA72;
                  text-align: center;
                  color: #ffffff;
                }
              }
              &.query-module{
                background-color: transparent;
                border: none;
                // position: absolute;
                // padding: 1% 0 1% 0;
                // top: 0;
                // right: .50rem;
                color: #D0AA72;
                // display: flex;
                // align-items: center;
                // .icon_add{
                //   // position: absolute;
                //   display: inline-block;
                //   width: 0.18rem;
                //   height: 0.18rem;
                //   min-width: 12px;
                //   min-height: 12px;
                //   border-radius: 50%;
                //   background: #D0AA72;
                //   text-align: center;
                //   color: #ffffff;
                //   margin-right: 0.08rem;
                //   position: relative;
                // //   .el-icon-plus{
                // //     position:absolute;
                // //     top: 9%;
                // //     left: 7%;
                // //  }
                // }
              }
              &.mock-btn{
                position: relative;
                a{
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                }
              }
              .fontsize-btn-medium();
            }
            // .icon_add{
            //   // display: inline-block;
            //   // width: 0.18rem;
            //   // height: 0.18rem;
            //   // min-width: 12px;
            //   // min-height: 12px;
            //   border-radius: 50%;
            //   background: #D0AA72;
            //   text-align: center;
            //   color: #ffffff;
            //   // line-height: 0.18rem;
            // }
            .downButton, .importButton {
              color: #D0AA72;
              font-size: 18px;
            }
            .message {
              color: #ff6c00;
              font-size: 18px;
            }
          }

          .check-module {

            .el-checkbox__input {
              .el-checkbox__inner {
                width: .2rem;
                height: .2rem;
                background: #fafafa;
                border: 1px solid #c7c7c7;
                border-radius: .04rem;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
              }
            }

            .el-checkbox__input.is-checked {
              .el-checkbox__inner {
                background: #409eff;
                border-color: #409eff;
              }

              .el-checkbox__inner::after {
                box-sizing: content-box;
                content: "";
                border: 1px solid #fff;
                border-left: 0;
                border-top: 0;
                height: .08rem;
                left: .07rem;
                position: absolute;
                top: 2px;
                -webkit-transform: rotate(45deg) scaleY(0);
                transform: rotate(45deg) scaleY(1.2);
                width: .03rem;
              }
            }

            .el-checkbox__label {
              vertical-align: middle;
              font-size: 18px;
            }
          }
        }
      }
    }
  }

  .el-main {
    overflow: inherit;
    display: flex;
    flex-wrap: wrap;
    padding: 0 0 0 5%;
    //padding-left: 5%;//新增，设置边框距离
    margin-bottom: 24px;
    .ocrIcon::after {
      content: "";
        display: inline-block;
        background-image: url(../../../static/assets/img/newCode/dataSourceIcon/OCR_ICON.png);
        background-size:cover;
        width: 40px;
        height: 20px;
        position: absolute;
        right: -50px;
        top: 10px;
    }
    .zzIcon::after {
      content: "";
        display: inline-block;
        background-image: url(../../../static/assets/img/newCode/dataSourceIcon/ZHONGZHENG.png);
        background-size:cover;
        width: 40px;
        height: 20px;
        position: absolute;
        right: -50px;
        top: 10px;
    }
    .zdIcon::after {
      content: "";
        display: inline-block;
        background-image: url(../../../static/assets/img/newCode/dataSourceIcon/ZHONGDENG.png);
        background-size:cover;
        width: 40px;
        height: 20px;
        position: absolute;
        right: -50px;
        top: 10px;
    }
    .el-form-item {
      position: relative;
      margin-right: 0;
      margin-bottom: 20px;
      display: flex;
      width: 45%;//占比设置
      .el-form-item__label {
        // font-size: 14px;
        padding: 8px;
        color:#343434;
        .fontsize-text-medium();
      }
      .el-form-item__content {
        width: 400px;
        .el-input {
          .el-input__inner {
            height: 40px;//修改
            padding-left:14px;
            box-sizing: border-box;
            // border: 1px solid;//添加边框格式
            border-radius: 5px;//添加四个圆角半径
            // .module-item-input();//原有边框的格式，进行注释
            font-size: 14px;//添加的，输入框input文本字体的大小
            color:#343434;
          }
          .el-input__inner:focus {
            border-color: rgba(70, 102, 234, 1);//原始
          }
          .el-form-item__error {
            width: 100%;
            z-index: 1;
          }
        }
        .el-input.is-disabled {
          .el-input__inner {
            // color: #c0c4cc;
            .module-item-input-disabled();
          }
        }
        .el-form-item__error {
          // .module-item-error();//错误提示语，前面的小标
        }
      }
      .el-form-item__error{
        font-size:14px;//修改字体
        z-index: 1;//设置不被下面组织覆盖，设置相对位置
      }
    }
    .long-el-form-item{
      width: 90%;
    }

    .el-form-item.is-success .el-input__inner {
      border-color: rgb(220, 223, 230);//原始
    }
        /* 设置验证成功时 el-textarea 组件的边框颜色为黄色 */
    .el-form-item.is-success .el-textarea__inner {
      border-color: rgb(220, 223, 230);//原始
    }
    .el-form-item.is-error {
      .el-input__inner {
        border-color: #f56c6c !important;
      }
    }
    .self-item{
      width: 100%;
      display: flex;
      // margin-left: 200px;
      margin-bottom: 20px;
    }
    .fieldset {
      // padding: 5px 20px;
      &.disabled{
          position: relative;
          &::before{
              display: block;
              content: "";
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              z-index: 2;
              background-color:rgba(255, 255, 255, 0.35);
              background-image: none;
          }

      }
  }
  }
  // .el-footer {
  //   height: auto !important;
  //   padding: 0 0 0 40%;
  //   .add-module {
  //     width:30%;
  //     border-radius: 0px !important;
  //     font-size: 24px !important;
  //     height: 50px;//修改后
  //     color: #ffffff !important;
  //     background: #e5c48a;
  //     margin-bottom: 50px;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/moduleItem.vue